/* SUMMARY
  * Imports
  * ColorDisplay: color display component
*/

/* Imports */
import { GenericDisplay, GenericDisplayProps } from "../00-generic/GenericDisplay";
import { color } from "../../../services/colors/colors";
/***/

/*
* ColorDisplay: color display component
* Used to display a technician or entity color swatch
*/

export interface ColorDisplayProps extends GenericDisplayProps {
  value?: string;
}

class ColorDisplay extends GenericDisplay<ColorDisplayProps> {
  getData = () => {
    const hex = this.props.value ? color.getColor(this.props.value, "500") : null;
    return (
      <div
        className="rounded-full w-6 h-6 border border-black/10 shadow-sm flex items-center justify-center inline-flex shrink-0"
        style={{
          backgroundColor: hex || "transparent",
        }}
      >
        {!hex && <span className="w-2.5 h-[2px] bg-gray-300 rounded-full block" />}
      </div>
    );
  };

  render() {
    return this.getData();
  }
}

export default ColorDisplay;
/***/